var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEnterpriseStudio(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 25.2,
    viewBox: "0 0 40 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-4-6h48v48H-4z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "iconLines",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.586 30H14l-3.293 3.293A1 1 0 0 0 11.414 35h17.172a1 1 0 0 0 .707-1.707L26 30h1.414L30 32.586A2 2 0 0 1 28.586 36H11.414A2 2 0 0 1 10 32.586L12.586 30zM39 23V3a2 2 0 0 0-2-2H3a2 2 0 0 0-2 2v20h38zm0 1H1v3a2 2 0 0 0 2 2h34a2 2 0 0 0 2-2v-3zM3 0h34a3 3 0 0 1 3 3v24a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3zm10 1h1v22h-1V1zm7.5 27a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm0-1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 5h7a.5.5 0 1 1 0 1h-7a.5.5 0 0 1 0-1zm0 3h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1zm0 6h7a.5.5 0 1 1 0 1h-7a.5.5 0 1 1 0-1zm0 3h6a.5.5 0 1 1 0 1h-6a.5.5 0 1 1 0-1zm0-6h6a.5.5 0 1 1 0 1h-6a.5.5 0 1 1 0-1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "iconBackground",
    d: "M14 1h23a2 2 0 0 1 2 2v20H14V1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "iconOrangeFill",
    d: "M26.5 6l-2 4h-4l3 3.5-1 4.5 4-2.5 4 2.5-1-4.5 3-3.5h-4z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterpriseStudio);
export default __webpack_public_path__ + "static/media/enterpriseStudio.7d420f1dfcb237c55653d95431985f3b.svg";
export { ForwardRef as ReactComponent };